function initBoujiPreSaleMessages(scope = document) {
  const roots = scope.querySelectorAll('[data-pre-sale-message-root]');

  roots.forEach((root) => {
    if (root.dataset.preSaleMessageInitialized === 'true') {
      return;
    }

    const productInfo = root.closest('.product-info, .product-related');
    const form = productInfo?.querySelector('form[is="product-form"]');
    const content = root.querySelector('[data-pre-sale-message-content]');
    const dataElement = root.querySelector('[data-pre-sale-variant-messages]');

    if (!productInfo || !form || !content) {
      return;
    }

    if (!dataElement) {
      return;
    }

    let parsedData;

    try {
      parsedData = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    const variantMessages = parsedData.messages || {};
    const defaultMessage = root.dataset.defaultMessage || '';

    const renderMessage = (variant) => {
      const variantId = variant?.id ? String(variant.id) : null;
      const variantMessage = variantId ? variantMessages[variantId] || '' : '';
      const nextMessage = variantMessage || defaultMessage;

      content.innerHTML = nextMessage;
    };

    form.addEventListener('variant:change', (event) => {
      renderMessage(event.detail.variant);
    });

    root.dataset.preSaleMessageInitialized = 'true';

    const idInput = form.querySelector('input[name="id"]');
    const initialVariantId = idInput ? String(idInput.value) : null;
    const initialVariant = initialVariantId ? { id: initialVariantId, title: 'initial-load' } : null;

    renderMessage(initialVariant);
  });
}

function initBoujiPreSaleGalleryIcons(scope = document) {
  const roots = scope.querySelectorAll('[data-gallery-pre-sale-root]');

  roots.forEach((root) => {
    if (root.dataset.preSaleGalleryInitialized === 'true') {
      return;
    }

    const gallery = root.closest('product-gallery');
    const formId = gallery?.getAttribute('form');
    const form = formId ? document.getElementById(formId) : null;
    const image = root.querySelector('[data-gallery-pre-sale-image]');
    const dataElement = root.querySelector('[data-gallery-pre-sale-variants]');

    if (!gallery || !form || !image) {
      return;
    }

    if (!dataElement) {
      return;
    }

    let parsedData;

    try {
      parsedData = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    const variantStates = parsedData.variants || {};
    const productHasPreSale = root.dataset.productHasPreSale === 'true';
    const featuredIconUrl = root.dataset.featuredIconUrl || '';
    const preSaleIconUrl = root.dataset.preSaleIconUrl || '';

    const renderIcon = (variant) => {
      const variantId = variant?.id ? String(variant.id) : null;
      const variantHasPreSale = variantId ? Boolean(variantStates[variantId]) : false;
      const hasPreSale = variantHasPreSale || productHasPreSale;

      let nextIconUrl = '';

      if (hasPreSale && preSaleIconUrl) {
        nextIconUrl = preSaleIconUrl;
      } else if (featuredIconUrl) {
        nextIconUrl = featuredIconUrl;
      }

      if (nextIconUrl) {
        image.src = nextIconUrl;
        image.hidden = false;
        root.hidden = false;
      } else {
        image.hidden = true;
        root.hidden = true;
      }
    };

    form.addEventListener('variant:change', (event) => {
      renderIcon(event.detail.variant);
    });

    root.dataset.preSaleGalleryInitialized = 'true';

    const idInput = form.querySelector('input[name="id"]');
    const initialVariantId = idInput ? String(idInput.value) : null;
    const initialVariant = initialVariantId ? { id: initialVariantId, title: 'initial-load' } : null;

    renderIcon(initialVariant);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initBoujiPreSaleMessages();
    initBoujiPreSaleGalleryIcons();
  });
} else {
  initBoujiPreSaleMessages();
  initBoujiPreSaleGalleryIcons();
}

document.addEventListener('shopify:section:load', (event) => {
  initBoujiPreSaleMessages(event.target);
  initBoujiPreSaleGalleryIcons(event.target);
});
